module.exports = __webpack_public_path__ + "img/icon-watched.5d352074.svg";